import { gql } from "@apollo/client";

export const SIGN_UP = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      message
      email
      id
      organizationId
    }
  }
`;

export const LOGIN_UP = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      message
      email
      accessToken
      refreshToken
      id
      organizationId
      tag
      accountDetails
      financeDetails
      user
      organization_role_id
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation GenOtp($email: String!) {
    genOtp(email: $email) {
      message
      email
      token
      otp
    }
  }
`;

export const VERIFY_PASSWORD_RESET_OTP = gql`
  mutation VerifyAndResetPasswordOtp(
    $otp: String!
    $newPassword: String!
    $token: String!
  ) {
    verifyAndResetPasswordOtp(
      otp: $otp
      newPassword: $newPassword
      token: $token
    ) {
      success
      message
    }
  }
`;

export const RESET_PASSWORD_ORG_USER = gql`
  mutation ResetPasswordOrgUser($newPassword: String!, $token: String!) {
    resetPasswordOrgUser(newPassword: $newPassword, token: $token) {
      success
      message
    }
  }
`;
